import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { useStateValue } from '../../state'

export const EditIssuerModal = ({ show, toggle, issuer }) => {
  const [currentState, dispatch] = useStateValue()
  const [stateObj, setStateObj] = useState(issuer)

  useEffect(() => {
    if (issuer) {
      setStateObj(issuer);
    }
  }, [issuer]);


  const commitStateObject = async () => {
    try {
      // switch data for mydata for update; See Item structure in dserv project
      const fullStateObj = { ...stateObj, mydata: stateObj.data }
      const resp = await client.post(
        `/account/admin_lti13.editIssuer/-/${currentState.issuer.id}`,
        fullStateObj
      )
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully edited the issuer."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      dispatch({ type: 'updateIssuer', issuer: resp.data.issuer })
    } catch (err) {
      console.log(err)
      let errMsg = "There was an error trying to update the Platform Instance."
      if (err.response) {
        errMsg = `Error: ${err.response.data.error}`
      }
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    } finally {
      toggle(!show)
    }
  }

  const handleDataChange = e => {
    const { data } = { ...stateObj }

    const { name, value, type, checked } = e.target
    if (type === 'checkbox') {
      data[name] = checked
    } else {
      data[name] = value
    }
    const nextStateObj = { ...stateObj, data }
    setStateObj(nextStateObj)
  }
  const handleNewJWKurlChange = e => {
    const { value } = e.target
    const nextStateObj = { ...stateObj, new_jwk_url: value }
    setStateObj(nextStateObj)

  }

  const helpTextStyle = {
    fontSize: "0.8em",
    color: "#6B5400"
  }
  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Platform Instance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="guid">
          <ControlLabel>Guid:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="guid"
            disabled
            value={stateObj && stateObj.data.guid ? stateObj.data.guid : ''}
          />
        </FormGroup>
        <FormGroup controlId="productfamilycode">
          <ControlLabel>Product Family Code </ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="productfamilycode"
            disabled
            value={stateObj && stateObj.data.product_family_code ? stateObj.data.product_family_code : ''}
          />
        </FormGroup>
        <FormGroup controlId="version">
          <ControlLabel>Version</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="version"
            disabled
            value={stateObj && stateObj.data.version ? stateObj.data.version : ''}
          ></FormControl>
        </FormGroup>
        <FormGroup controlId="name">
          <ControlLabel>Name</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="name"
            value={stateObj && stateObj.data.name ? stateObj.data.name : ''}
          ></FormControl>
        </FormGroup>
        <FormGroup controlId="auth_url">
          <ControlLabel>Authentication URL</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="auth_url"
            value={stateObj && stateObj.data.auth_url ? stateObj.data.auth_url : ''}
          ></FormControl>
        </FormGroup>
        <FormGroup controlId="token_url">
          <ControlLabel>Token URL</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="token_url"
            value={stateObj && stateObj.data.token_url ? stateObj.data.token_url : ''}
          ></FormControl>
        </FormGroup>
        <FormGroup controlId="aud">
          <ControlLabel>JWK Audience Claim</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="aud"
            value={stateObj && stateObj.data.aud ? stateObj.data.aud : ''}
          ></FormControl>
          <div style={helpTextStyle}>
            Sets the audience claim when signing JWKs. Generally is the same as the Token URL but not always. Do not modify this unless you understand what this means.
          </div>
        </FormGroup>
        <FormGroup>
          <ControlLabel>New JWK URLs</ControlLabel>
          <FormControl
            value={stateObj && stateObj.new_jwk_url ? stateObj.new_jwk_url : ''}
            onChange={handleNewJWKurlChange} type='text' name="new_jwk_url" />
          <div style={helpTextStyle}>
            Add one URL for a new JWK to add to the issuer.keystore
          </div>
        </FormGroup>
        <FormGroup controlId="useEmailLogin">
          <ControlLabel>Use Email Login:</ControlLabel>
          <Checkbox
            className="ml-2 mb-4"
            inline
            onChange={handleDataChange}
            name="usesInstitutionCourses"
            checked={stateObj && stateObj.data && stateObj.data.email_login ? true : false}
          />
        </FormGroup>
        <FormGroup controlId="useLTIlogin">
          <ControlLabel>Use LTI Login:</ControlLabel>
          <Checkbox
            className="ml-2 mb-4"
            inline
            onChange={handleDataChange}
            name="useLTIlogin"
            checked={stateObj && stateObj.data && stateObj.data.lti_login ? true : false}
          />
        </FormGroup>
        <FormGroup controlId="useJWTlogin">
          <ControlLabel>Use Institution Courses:</ControlLabel>
          <Checkbox
            className="ml-2 mb-4"
            inline
            onChange={handleDataChange}
            name="useJWTlogin"
            checked={stateObj && stateObj.data && stateObj.data.jwt_login ? true : false}
          />
        </FormGroup>

        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => commitStateObject()}
        >
          <div className="far fa-plus fa-fw mr-2" /> Update
        </div>
      </Modal.Body>
    </Modal>
  )
}
// <div style={helpTextStyle}>
//   If checked, use the list defined below instead of the users course memberships to populate the course list
// </div>

EditIssuerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  issuer: PropTypes.object
}
